import { createAction } from 'redux-actions';
import * as types from '../constants/ActionTypes';

export const updateNarrowState = createAction(types.UPDATE_NARROW_STATE);
export const nextStep = createAction(types.NEXT_STEP);
export const prevStep = createAction(types.PREV_STEP);
export const startSubmitLoading = createAction(types.START_SUBMIT_LOADING);
export const acceptTerms = createAction(types.ACCEPT_TERMS);
export const toggleAbandonBasketTerms = createAction(
  types.TOGGLE_ABANDON_BASKET_TERMS
);
export const setOriginalAgencyInfo = createAction(
  types.SET_ORIGINAL_AGENCY_INFO
);
export const firePayButtonClick = createAction(types.FIRE_PAY_BUTTON_CLICK);
export const updateBookingOverview = createAction(
  types.UPDATE_BOOKING_OVERVIEW
);
export const receivedDibsForm = createAction(types.RECEIVED_DIBS_FORM);
export const updateTotalSteps = createAction(types.UPDATE_TOTAL_STEPS);
export const stopLoading = createAction(types.STOP_LOADING);
export const customerLeave = createAction(types.CUSTOMER_LEAVE);
export const hideAbandonBasket = createAction(types.HIDE_ABANDON_BASKET);
export const updateAbandonBasketState = createAction(
  types.UPDATE_ABANDON_BASKET_STATE
);
